import { approvalsTabUIInitialState } from "./uiLandingPageApprovalsTabState";

export const makeApprovalsTabUIActions = (set, get) => ({
  setShowApprovalsDelForm: (show) =>
    set((s) => ({
      approvalsTabUI: { ...s.approvalsTabUI, showApprovalsDelForm: !!show },
    })),
  setShowApprovedDelForm: (show) =>
    set((s) => ({
      approvalsTabUI: { ...s.approvalsTabUI, showApprovedDelForm: !!show },
    })),
  setShowTransferApprovalModal: (show) =>
    set((s) => ({
      approvalsTabUI: {
        ...s.approvalsTabUI,
        showTransferApprovalModal: !!show,
      },
    })),
  setActiveApprovalTab: (tab) =>
    set((s) => ({
      approvalsTabUI: { ...s.approvalsTabUI, activeApprovalTab: tab },
    })),
  resetApprovalsTabUI: () =>
    set({ approvalsTabUI: approvalsTabUIInitialState }),
});
